var $1b0393182473bf9e$exports = {};
$1b0393182473bf9e$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " nincs kijel\xF6lve.");
  },
  "longPressToSelect": "Nyomja hosszan a kijel\xF6l\xE9shez.",
  "select": "Kijel\xF6l\xE9s",
  "selectedAll": "Az \xF6sszes elem kijel\xF6lve.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Egy elem sincs kijel\xF6lve",
      one: function one() {
        return "".concat(formatter.number(args.count), " elem kijel\xF6lve");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elem kijel\xF6lve");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " kijel\xF6lve.");
  }
};
export { $1b0393182473bf9e$exports as default };